import { render } from "./ModalProduct.vue?vue&type=template&id=5aaaf69a&scoped=true"
import script from "./ModalProduct.vue?vue&type=script&lang=js"
export * from "./ModalProduct.vue?vue&type=script&lang=js"

import "./ModalProduct.vue?vue&type=style&index=0&id=5aaaf69a&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\wwwda\\OneDrive\\Desktop\\проекты-и-учебные-файлы-front\\pizzares\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aaaf69a"]])

export default __exports__